module.exports = "<div class=\"o-box--46by60 u-pointer-none u-block u-w2of2\"></div>\n";
